
<p-toast></p-toast>


<div class="chat-container" style="height:100%;position:relative">
  <!-- Chat Messages Section -->
  <!--<div style="display:flex;justify-content:center;align-items:center;width:100%;padding:10px;height:10%">
  Chat
</div>-->
@if (skeltonLoad) {
  <div #chatWindow style="height: 90%; overflow-y: auto; position: relative; background: #e5ddd5 ">
    <!--<div *ngIf="isDragging" class="drag-overlay">
    <p>Drop your file here</p>
  </div>-->
  <div class="chat-window">
    <div style="display:flex;justify-content:center;align-items:center;width:100%">
      <span class="chatdate"><p-skeleton width="6.5rem" styleClass="mb-1"></p-skeleton></span>
    </div>
    <div class="user-message-showname">
      <p-skeleton width="6rem" styleClass="mb-1"></p-skeleton>
    </div>
    <div class="message user-message">
      <!-- Text Message -->
      <div class="message-content">
        <p-skeleton width="8rem" styleClass="mb-1"></p-skeleton>
      </div>
      <div class="message-timestamp">
        <p-skeleton width="2rem" height="0.7rem" styleClass="mb-1"></p-skeleton>
        <span class="user-seen-display">
          <p-skeleton width="1rem" height="0.7rem" styleClass="mb-1"></p-skeleton>
        </span>
      </div>
    </div>
    <div class="agent-message-showname">
      <p-skeleton width="6rem" styleClass="mb-1"></p-skeleton>
    </div>
    <div class="message agent-message">
      <!-- Text Message -->
      <div class="message-content">
        <p-skeleton width="8rem" styleClass="mb-1"></p-skeleton>
      </div>
      <div class="message-timestamp">
        <p-skeleton width="2rem" height="0.7rem" styleClass="mb-1"></p-skeleton>
        <span class="agent-seen-display">
          <p-skeleton width="1rem" height="0.7rem" styleClass="mb-1"></p-skeleton>
        </span>
      </div>
    </div>
    <div style="display:flex;justify-content:center;align-items:center;width:100%">
      <span class="chatdate"><p-skeleton width="6.5rem" styleClass="mb-1"></p-skeleton></span>
    </div>
    <div class="user-message-showname">
      <p-skeleton width="6rem" styleClass="mb-1"></p-skeleton>
    </div>
    <div class="message user-message">
      <!-- Text Message -->
      <div class="message-content">
        <p-skeleton width="8rem" styleClass="mb-1"></p-skeleton>
      </div>
      <div class="message-timestamp">
        <p-skeleton width="2rem" height="0.7rem" styleClass="mb-1"></p-skeleton>
        <span class="user-seen-display">
          <p-skeleton width="1rem" height="0.7rem" styleClass="mb-1"></p-skeleton>
        </span>
      </div>
    </div>
    <div class="agent-message-showname">
      <p-skeleton width="6rem" styleClass="mb-1"></p-skeleton>
    </div>
    <div class="message agent-message">
      <!-- Text Message -->
      <div class="message-content">
        <p-skeleton width="8rem" styleClass="mb-1"></p-skeleton>
      </div>
      <div class="message-timestamp">
        <p-skeleton width="2rem" height="0.7rem" styleClass="mb-1"></p-skeleton>
        <span class="agent-seen-display">
          <p-skeleton width="1rem" height="0.7rem" styleClass="mb-1"></p-skeleton>
        </span>
      </div>
    </div>
  </div>
</div>
}
@if (chatShow) {
  <div #chatWindow style="height: 90%; overflow-y: auto; position: relative; background: #e5ddd5 " (dragover)="OnDragOver($event)"
    (dragleave)="OnDragLeave($event)"
    (drop)="OnDrop($event)"
    [class.dragging]="isDragging">
    <!--<div *ngIf="isDragging" class="drag-overlay">
    <p>Drop your file here</p>
  </div>-->
  @for (msg of messages; track msg; let m = $index) {
    <div class="chat-window">
      @if (msg.dateChanged) {
        <div id="shs{{m}}" style="display:flex;justify-content:center;align-items:center;width:100%">
          <span class="chatdate">{{ msg.date }}</span>
        </div>
      }
      @if (!msg.dateChanged) {
<div id="shsshhs{{m}}" [ngClass]="{
        'user-message-showname': (msg.sender === 'User' && sender == 'User') || (msg.sender === 'Agent' && sender == 'Agent'),
        'agent-message-showname': (msg.sender === 'Agent' && sender == 'User') || (msg.sender === 'User' && sender == 'Agent')}">
          {{ msg.senderName }}
        </div>
      }
      @if (!msg.dateChanged) {
<div id="shjsjs{{m}}" [ngClass]="{
        'user-message': (msg.sender === 'User' && sender == 'User') || (msg.sender === 'Agent' && sender == 'Agent'),
        'agent-message': (msg.sender === 'Agent' && sender == 'User') || (msg.sender === 'User' && sender == 'Agent')}" class="message">
          <!-- Text Message -->
          @if (!msg.isFile && !msg.isImage) {
            <div class="message-content">
              {{ msg.content }}
            </div>
          }
          <!-- Image Message -->
          @if (msg.isImage) {
            <div>
              <div class="row m-0">
                @for (fileurl of msg.fileUrl; track fileurl; let o = $index) {
                  <div class="p-0" [ngClass]="msg.fileUrl.length === 1 ? 'col-md-12' : 'col-md-6'" style=" position: relative; text-align: center; display: flex; justify-content: center;height: 140px;">
                    <img [src]="fileurl" id="{{m}}{{o}}" (click)="OpenImage(fileurl)" alt="Uploaded Image" />
                    <div class="btn-circle-download" id="btn-circle-download{{m}}{{o}}" (click)="DownloadImage(fileurl,m,o)" style=" position: absolute; bottom: -24px;">
                      <svg id="arrow" width="14px" height="20px" viewBox="17 14 14 20">
                        <path d="M24,15 L24,32"></path>
                        <polyline points="30 27 24 33 18 27"></polyline>
                      </svg>
                      <svg id="check" width="21px" height="15px" viewBox="13 17 21 15">
                        <polyline points="32.5 18.5 20 31 14.5 25.5"></polyline>
                      </svg>
                      <svg id="border" width="48px" height="48px" viewBox="0 0 48 48">
                        <path d="M24,1 L24,1 L24,1 C36.7025492,1 47,11.2974508 47,24 L47,24 L47,24 C47,36.7025492 36.7025492,47 24,47 L24,47 L24,47 C11.2974508,47 1,36.7025492 1,24 L1,24 L1,24 C1,11.2974508 11.2974508,1 24,1 L24,1 Z"></path>
                      </svg>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
          <!-- PDF/File Message -->
          @if (msg.isFile && !msg.isImage) {
            <div class="message-file">
              @for (fileurl of msg.fileUrl; track fileurl; let o = $index) {
                <div class="pdf-chat-item">
                  <div class="pdf-icon">
                    <i class="fas fa-file" style="font-size:25px;color:orangered"></i>
                  </div>
                  <div class="pdf-details">
                    <span class="pdf-name">{{ fileurl.split("//")[fileurl.split("//").length - 1]  }}</span>
                  </div>
                  <div class="pdf-download">
                    <button class="download-btn" (click)="DownloadImage(fileurl,m,o)">
                      <i class="fas fa-circle-arrow-down" style="font-size:25px;color:black;" id="btn-circle-download{{m}}{{o}}"></i>
                    </button>
                  </div>
                </div>
              }
              <!--<div *ngFor="let fileurl of msg.fileUrl;let o=index" style=" position: relative; text-align: center; display: flex; justify-content: center;">
              📄<a [href]="fileurl" download></a>
              <div class="btn-circle-download" id="btn-circle-download{{m}}{{o}}" (click)="DownloadImage(fileurl,m,o)" style=" position: absolute; bottom: -24px;">
                <svg id="arrow" width="14px" height="20px" viewBox="17 14 14 20">
                  <path d="M24,15 L24,32"></path>
                  <polyline points="30 27 24 33 18 27"></polyline>
                </svg>
                <svg id="check" width="21px" height="15px" viewBox="13 17 21 15">
                  <polyline points="32.5 18.5 20 31 14.5 25.5"></polyline>
                </svg>
                <svg id="border" width="48px" height="48px" viewBox="0 0 48 48">
                  <path d="M24,1 L24,1 L24,1 C36.7025492,1 47,11.2974508 47,24 L47,24 L47,24 C47,36.7025492 36.7025492,47 24,47 L24,47 L24,47 C11.2974508,47 1,36.7025492 1,24 L1,24 L1,24 C1,11.2974508 11.2974508,1 24,1 L24,1 Z"></path>
                </svg>
              </div>
            </div>-->
          </div>
        }
        <!-- Timestamp -->
        <div class="message-timestamp" [ngStyle]="{
        'justify-content:end': (msg.sender === 'User' && sender == 'User') || (msg.sender === 'Agent' && sender == 'Agent'),
        'justify-content:start': (msg.sender === 'Agent' && sender == 'User') || (msg.sender === 'User' && sender == 'Agent')}">
          {{ msg.timestamp }}
          <span [ngClass]="{
        'user-seen-display': (msg.sender === 'User' && sender == 'User') || (msg.sender === 'Agent' && sender == 'Agent'),
        'agent-seen-display': (msg.sender === 'Agent' && sender == 'User') || (msg.sender === 'User' && sender == 'Agent')}">
            @if (msg.seen) {
              <i class="fas fa-check-double" style="color: blue; font-size: 12px;"></i>
            }
            @if (!msg.seen) {
              <i class="fas fa-check" style="color: blue; font-size: 12px;"></i>
            }
          </span>
        </div>
      </div>
    }
  </div>
}
</div>
}

<!-- New Message Indicator -->
@if (newMessageFlag) {
  <div class="new-message-icon" (click)="scrollToLatestMessage()">
    🔔 New Message
  </div>
}

<!-- File Upload & Input Section -->
<!--<div class="chat-input-container px-5 py-4" style="height:10%;">-->
<!-- File Upload Button -->
<!--<label class="file-upload-label">
📎
<input type="file" (change)="handleFileUpload($event)" accept="image/*,.pdf" class="file-upload-input" />
</label>-->
<!--<div class="chat-attachment-container">-->
<!-- Attachment Button -->
<!--<button (click)="ToggleMenu()" class="attachment-btn">
📎
</button>-->
<!--<div class="icon-container" (click)="ToggleMenu()">-->
<!-- Icon element with rotation class based on a condition -->
<!--<i class="fas fa-plus icon" [class.rotate]="menuVisible"></i>
</div>-->
<!-- Attachment Menu -->
<!--<div *ngIf="menuVisible" class="attachment-menu">
<div class="menu-item" (click)="OnAttach('document')">
  <i class="fas fa-file"></i> Document
</div>
<div class="menu-item" (click)="OnAttach('photos')">
  <i class="fas fa-image"></i> Photos & Videos
</div>

</div>
</div>-->
<!-- Message Input -->
<!--<input type="text" [(ngModel)]="newMessage" (paste)="OnPaste($event)" (keyup.enter)="SendMessage()" placeholder="Type a message" class="chat-input" />-->
<!-- Send Button -->
<!--<button (click)="SendMessage()" class="send-button">
➤
</button>
</div>-->
@if (menuVisible) {
  <div class="attachment-menu">
    <div class="menu-item" (click)="OnAttach('document')">
      <i class="fas fa-file"></i> Document
    </div>
    <div class="menu-item" (click)="OnAttach('photos')">
      <i class="fas fa-image"></i> Photos & Videos
    </div>
  </div>
}
@if (speechToTextTab) {
  <div style="padding: 15px; /* border: 1px solid silver; */ border-radius: 5px; position: absolute; bottom: 87px; left: 16px; box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;min-width:500px;background-color:white  ">
    <div style="width:100%;display:flex">
      <div style="width:40%;display:flex;justify-content:start;align-items:center">
        <span id="speaktotextcom">{{spechtotextCommand}}</span>
      </div>
      <div style="width: 50%; display: flex; justify-content: start; align-items: center">
        <button id="speech" class="btn" (click)="StartListening()">
          <i class="fas fa-microphone"></i>
          <div class="pulse-ring"></div>
        </button>
      </div>
      <div style="width: 10%; display: flex; justify-content: end;">
        <i class="fas fa-close" (click)="popupcloselisten()"></i>
      </div>
    </div>
  </div>
}
@if (emojisTab) {
  <div class="emoji-picker">
    <!-- Search Bar -->
    <!--<div class="search-bar">
    <span class="p-input-icon-left">
      <i class="pi pi-search"></i>
      <input pInputText
        type="text"
        placeholder="Search emojis"
        [(ngModel)]="searchText" />
      </span>
    </div>-->
    <!-- Category Tabs -->
    <p-tabView>
      @for (category of categories; track category) {
        <p-tabPanel [header]="category.name">
          <div class="emoji-grid">
            @for (emoji of FilterEmojis(category.emojis); track emoji) {
              <span class="emoji" (click)="OnEmojiClick(emoji)">{{ emoji }}</span>
            }
          </div>
        </p-tabPanel>
      }
    </p-tabView>
  </div>
}

<div class="--dark-theme" id="chat">
  <div class="chat__conversation-panel">
    <!-- Attachment Menu -->

    <div class="chat__conversation-panel__container">
      <button class="chat__conversation-panel__button panel-item btn-icon add-file-button" (click)="ToggleMenu()">
        <svg [class.rotate]="menuVisible" class="feather feather-plus sc-dnqmqq jxshSx" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <line x1="12" y1="5" x2="12" y2="19"></line>
          <line x1="5" y1="12" x2="19" y2="12"></line>
        </svg>
      </button>

      <button class="chat__conversation-panel__button panel-item btn-icon emoji-button" (click)="ToggleEmojisTabMenu()">
        <svg class="feather feather-smile sc-dnqmqq jxshSx" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="10"></circle>
          <path d="M8 14s1.5 2 4 2 4-2 4-2"></path>
          <line x1="9" y1="9" x2="9.01" y2="9"></line>
          <line x1="15" y1="9" x2="15.01" y2="9"></line>
        </svg>
      </button>

      <input class="chat__conversation-panel__input panel-item" [(ngModel)]="newMessage" (paste)="OnPaste($event)" (keyup.enter)="SendMessage()" placeholder="Type a message..." />
      <button class="chat__conversation-panel__button panel-item btn-icon emoji-button" style="height:40px" (click)="ToggleVoiceToTextTab()">
        <div class="tooltip-container">
          <i class="fas fa-microphone icon-tool" style="color:white;font-size:19px"></i>
          <span class="tooltip-text">Speech To Text</span>
        </div>
      </button>
      <button class="chat__conversation-panel__button panel-item btn-icon send-message-button" (click)="SendMessage()">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" data-reactid="1036">
          <line x1="22" y1="2" x2="11" y2="13"></line>
          <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
        </svg>
      </button>
    </div>
  </div>

</div>


<!-- Image Popup -->
@if (showImagePopup) {
  <div class="image-popup" (click)="CloseImage()">
    <img [src]="popupImageUrl" alt="Popup Image" />
  </div>
}
</div>

